import moment from 'moment';
import React, { useEffect, useState } from "react";
import S3 from 'react-aws-s3';
import { useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from 'react-signature-canvas';
import aprobadorService from "../services/aprobador.service";
import calculoService from "../services/calculo.service";
import causalService from "../services/causal.service";
import correoService from "../services/correo.service";
import documentoService from "../services/documento.service";
import emailService from "../services/email.service";
import personaService from "../services/persona.service";

import { Oval } from 'react-loader-spinner';

/** Material UI */
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { MenuItem } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid, esES } from '@mui/x-data-grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import esLocale from 'date-fns/locale/es';
import { SnackbarProvider, useSnackbar } from 'notistack';


function _arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

/** Estilos CSS MUI */
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const FiniquitoParte2 = () => {
    const { id_causal } = useParams();
    const [causal, setCausal] = useState('');
    const [aprobado, setAprobado] = useState([]);
    const [persona, setPersona] = useState('');
    const [sigPad, setSigPad] = useState({});
    const [haberes, setHaberes] = useState('');
    const [detalleHaberes, setDetalleHaberes] = useState('');
    const [dias, setDias] = useState('');
    const [detalleDias, setDetalleDias] = useState('');
    const [descanso, setDescanso] = useState('');
    const [detalleDescanso, setDetalleDescanso] = useState('');
    const [equipo, setEquipo] = useState('');
    const [detalleEquipo, setDetalleEquipo] = useState('');
    const [calculo, setCalculo] = useState([]);
    const [finiquito, setFiniquito] = useState('');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [archivo, setArchivo] = useState('');
    const [nombrearchivo, setNombreArchivo] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [rut, setRut] = useState('');
    let navigate = useNavigate();
    const [correos, setCorreos] = useState([]);
    const [turno, setTurno] = useState('');
    const [ultimodiaturno, setUltimodiaturno] = useState('');
    const [loading, setLoading] = useState(false);
    const [comentarioRRHH, setComentarioRRHH] = useState('');

    useEffect(() => {
        console.log(id_causal);
        causalService.getId(id_causal)
            .then(c => {
                console.log(c);
                setCausal(c.data);
                setAprobado(c.data.aprobado);
                setPersona(c.data.persona);
                retreiveCalculos(id_causal);
                retreiveCorreos();
                setComentarioRRHH(c.data.comentario_rrhh);
            })
            .catch(err => {
                console.log(err);
            });
    }, []);

    const retreivePersonaXRut = () => {
        personaService.getPorRut(rut)
            .then(persona => {
                console.log(persona.data[0]);
                setPersona(persona.data[0]);
            });
    }

    function retreiveCalculos(id_causal) {
        calculoService.getByIdCausal(id_causal)
            .then(resp => {
                console.log(resp.data);
                setCalculo(resp.data);
                resp.data.map(c => {
                    if (c.nombre === "Haberes Pendientes (RRHH)") {
                        setHaberes(c.valor);
                        setDetalleHaberes(c.detalle);
                    }
                    if (c.nombre === "Días hábiles/ feriado a pagar (RRHH)") {
                        setDias(c.valor);
                        setDetalleDias(c.detalle);
                    }
                    if (c.nombre === "Días descanso jornada excepcional a pagar (RRHH)") {
                        setDescanso(c.valor);
                        setDetalleDescanso(c.detalle);
                    }
                    if (c.nombre === "Entrega de equipos (Secretaria)") {
                        setEquipo(c.valor);
                        setDetalleEquipo(c.detalle);
                    }
                    if (c.fecha_finiquito !== "") {
                        setFiniquito(c.fecha_finiquito);
                    }
                })
            })
            .catch(err => {
                console.error(err);
            });
    }

    function retreiveCorreos() {
        correoService.getAll()
            .then(resp => {
                console.log(resp.data);
                setCorreos(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const limpiarFirma = () => {
        sigPad.clear();
    }

    const handleHaberes = (event) => {
        console.log("VALOR", event.target.value);
    }

    const Ingresar = async () => {
        console.log(ultimodiaturno);
        var contador = 0;
        var arr_ingreso = [];
        if (persona.estado_desv === "Desvinculado") {
            alert("La persona ya se encuntra desvinculada");
            return;
        }
        if (!turno) {
            alert("Debe ingresar el turno del trabajdor");
            return;
        }
        if (!ultimodiaturno) {
            alert("Debe ingresar el ultimo día efectivo trabajado del trabajador");
            return;
        }
        if (!haberes) {
            alert("Debe ingresar una opción en Haberes Pendientes");
            return;
        }
        if (!dias) {
            alert("Debe ingresar una opción en Días hábiles pendientes");
            return;
        }
        if (!descanso) {
            alert("Debe ingresar una opción en Días de descanso");
            return;
        }
        if (!equipo) {
            alert("Debe ingresar una opción en Entrega de equipos");
            return;
        }
        if (!finiquito) {
            alert("Debe ingresar una fecha de finiquito");
            return;
        }
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        console.log("HABERES", haberes);
        if (haberes === "SI") {
            if (!detalleHaberes) {
                alert("Falta ingresar detalle de Haberes Pendientes");
                return;
            }
            arr_ingreso.push({ nombre: "Haberes Pendientes (RRHH)", valor: "SI", detalle: detalleHaberes, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        } else {
            arr_ingreso.push({ nombre: "Haberes Pendientes (RRHH)", valor: "NO", detalle: detalleHaberes, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        }
        if (dias === "SI") {
            if (!detalleDias) {
                alert("Falta ingresar detalle de Dias hábiles");
                return;
            }
            arr_ingreso.push({ nombre: "Días hábiles/ feriado a pagar (RRHH)", valor: "SI", detalle: detalleDias, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        } else {
            arr_ingreso.push({ nombre: "Días hábiles/ feriado a pagar (RRHH)", valor: "NO", detalle: detalleDias, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        }
        if (descanso === "SI") {
            if (!detalleDescanso) {
                alert("Falta ingresar detalle de Días de descanso jornada excepcional");
                return;
            }
            arr_ingreso.push({ nombre: "Días descanso jornada excepcional a pagar (RRHH)", valor: "SI", detalle: detalleDescanso, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        } else {
            arr_ingreso.push({ nombre: "Días descanso jornada excepcional a pagar (RRHH)", valor: "NO", detalle: detalleDescanso, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        }
        if (equipo === "SI") {
            if (!detalleEquipo) {
                alert("Falta ingresar detalle de Entrega de equipos");
                return;
            }
            arr_ingreso.push({ nombre: "Entrega de equipos (Secretaria)", valor: "SI", detalle: detalleEquipo, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        } else {
            arr_ingreso.push({ nombre: "Entrega de equipos (Secretaria)", valor: "NO", detalle: detalleEquipo, fecha_mod: new Date(), tipo: "RRHH", id_causal: causal.id, fecha_finiquito: finiquito, turno: turno, ultimo_dia: ultimodiaturno })
        }

        setLoading(true);

        for (var i in arr_ingreso) {
            var cl = calculo.find(v => v.nombre === arr_ingreso[i].nombre);
            if (cl) {
                let cup = await calculoService.update(cl.id, arr_ingreso[i]);
                console.log("UPDATE", cup.data.message);
                let up_causal = await causalService.update(id_causal, { comentario_rrhh: comentarioRRHH });
                if (up_causal) {
                    console.log("UPDATEA CAUSAL", up_causal);
                }
                contador++;
            } else {
                let cal = await calculoService.ingresar(arr_ingreso[i]);
                console.log(cal);
                if (cal) {
                    let up_causal = await causalService.update(id_causal, { comentario_rrhh: comentarioRRHH });
                    if (up_causal) {
                        console.log("UPDATEA CAUSAL", up_causal);
                    }
                    contador++;
                }
            }
        }

        var f = sigPad.toDataURL();
        var fr = f.split(',');

        console.log("Contador", contador);

        const dataap = {
            tipo: "RRHH",
            fecha: Date.now(),
            firma: fr[1],
            id_causal: causal.id
        }

        console.log("Aprobador", aprobado);
        if (contador === arr_ingreso.length) {
            var ap = aprobado.find(v => v.tipo === "RRHH");
            if (ap) {
                //Actualizamos
                aprobadorService.update(ap.id, dataap)
                    .then(resp => {
                        console.log(resp.data.message);
                    })
                    .catch(err => {
                        console.error(err);
                    });
            } else {
                //Ingresamos
                aprobadorService.ingresar(dataap)
                    .then(a => {
                        console.log(a);
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }

        /** Enviamos mail a Finanzas 1 */
        var html = crearHtmlEnvio(new Date().toString(), causal.id, persona);
        var crr = correos.filter(v => v.destino === "FINANZAS");
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        }
        const _data_mail = {
            nombre: "RRHH",
            mensaje: html,
            email: send
        }
        //Envío correo a RRHH
        emailService.sendMail(_data_mail)
            .then(async response => {
                console.log(response);
                const pers = await personaService.update(persona.id, { estado_desv: "En Finanzas 1" });
                console.log(pers.data);
                setLoading(false);
                enqueueSnackbar('Correos enviados correctamente!', { variant: "success" });
                setTimeout(() => {
                    navigate("/salidar");
                }, 3000);
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
                enqueueSnackbar('Error al enviar correo!', { variant: "error" });
            });
    };

    function crearHtmlEnvio(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Desvinculación</h3></center><br/>";
        html = html + "<center><h3>Aviso de Modificación de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una modificación a la desvinculación, por favor revisar a traves del siguiente link: </p> <a href="${baseurl}/finiquito3/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlGerencia(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita su aprobación a traves del siguiente link: </p> <a href='${baseurl}/finiquitoger/${id_causal}'>${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    function crearHtml(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita completar información a traves del siguiente link: </p> <a href="${baseurl}/finiquito3/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    /** Data de Documentos */
    const columns = [{
        field: "nombre", headerName: "Nombre", flex: 1
    }, {
        field: "ruta", headerName: "Descarga", flex: 1, renderCell: (cellValues) => {
            return (
                <a href={cellValues.row.ruta} target="_blank"><Button variant="contained" endIcon={<AttachFileIcon />}>Descargar</Button></a>
            );
        }
    } /* {
        field: "id", headerName: "Eliminar", flex: 1, renderCell: (cellValues) => {
            return (
                <div>
                    <IconButton aria-label="delete" onClick={() => setConfirmOpen(true)}>
                        <DeleteIcon />
                    </IconButton>
                    <AlertDialog
                        title="Eliminar el Documento?"
                        open={confirmOpen}
                        setOpen={setConfirmOpen}
                        onConfirm={() => eliminarDoc(cellValues.row.id)}
                    >
                        Esta seguro de eliminar el Documento?
                    </AlertDialog>
                </div>
            )
        }
    } */];

    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    const guardarDocumento = async () => {
        if (!nombrearchivo) {
            enqueueSnackbar('Falta nombre de archivo!', { variant: "error" });
            return;
        }
        if (!archivo) {
            enqueueSnackbar('Falta adjuntar archivo!', { variant: "error" });
            return;
        }
        console.log({
            "Nombre Archivo": nombrearchivo,
            "Documento": archivo[0]
        });
        if (!persona) {
            enqueueSnackbar('Debe buscar a la Persona!', { variant: "error" });
            return;
        }

        //Guardamos documento en S3 AWS
        var dir = persona.Rut.replace(/\./g, '');
        const config = {
            bucketName: 'docreclutav2',
            dirName: dir + "/hojavida",
            acl: 'public-read',
            //dirName: 'photos', /* optional */
            region: 'sa-east-1',
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY
        }
        const ReactS3Client = new S3(config);
        console.log("CONFIG S3", config);
        var extension = archivo[0].name.split('.').pop();
        console.log("EXT", extension);
        var ruta = "";
        window.Buffer = window.Buffer || require("buffer").Buffer;
        let doc = await ReactS3Client.uploadFile(archivo[0], nombrearchivo + "." + extension);
        if (doc) {
            ruta = doc.location;
        } else {
            enqueueSnackbar('Ocurrio un problema al subir el Archivo!', { variant: "error" });
            return;
        }

        //Ingresamos el documento
        documentoService.ingresar({ nombre: nombrearchivo, personaId: persona.id, ruta: ruta })
            .then(resp => {
                console.log(resp);
            })
            .catch(err => {
                console.error(err);
            });
        setArchivo('');
        setNombreArchivo('');
        retreivePersonaXRut();
        closeModal();
    }

    return (
        loading ? (
            <div>
                <div className="d-flex justify-content-center">
                    <Oval
                        heigth="100"
                        width="100"
                        color='blue'
                        ariaLabel='loading'
                    />
                </div>
                <p className="text-center">Cargando ...</p>
            </div>
        ) : (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="text-center">
                            <h2>Datos de Trabajador</h2>
                        </div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>Rut:</td>
                                    <td>{persona.Rut}</td>
                                </tr>
                                <tr>
                                    <td>Nombre</td>
                                    <td>{persona ? persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno : ""}</td>
                                </tr>
                                <tr>
                                    <td>Unidad de Negocio:</td>
                                    <td>{persona.ctoDescripcion}</td>
                                </tr>
                                <tr>
                                    <td>Cargo:</td>
                                    <td>{persona.recDescripcion}</td>
                                </tr>
                                <tr>
                                    <td>Fecha Ingreso:</td>
                                    <td>{persona ? moment(persona.FechaContratoInicial).local().format('DD/MM/YYYY') : ""}</td>
                                </tr>
                                <tr>
                                    <td>Prceso de Desvinculación</td>
                                    <td>{persona.estado_desv}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <h2 className="text-center">Datos Causal</h2>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>Causal de Despido:</td>
                                <td>{causal.descripcion}</td>
                            </tr>
                            <tr>
                                <td>Fecha Solicitud:</td>
                                <td>{moment(causal.fecha_ingreso).local().format('DD/MM/YYYY hh:mm:ss')}</td>
                            </tr>
                            <tr>
                                <td>Comentarios:</td>
                                <td>{causal.comentario}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="text-center">
                            <button className="btn btn-secondary" onClick={openModal}>Subir Documentos Complementarios</button>
                        </div>
                    </div>
                </div>
                <div className="row mt-3 justify-content-center">
                    <div className="col-12">
                        <h3 style={{ textAlign: "center" }}>Documentos Complementarios Desvinculación</h3>
                        <div style={{ height: 250, width: '100%' }}>
                            <DataGrid
                                sx={{
                                    boxShadow: 2,
                                    border: 2,
                                    borderColor: 'primary.light',
                                    '& .MuiDataGrid-cell:hover': {
                                        color: 'primary.main',
                                    },
                                }}
                                rows={persona ? persona.documento : []}
                                columns={columns}
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            />
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="text-center">
                        <h2>CONSIDERACIONES PARA EL CALCULO DE FINIQUITO DEL TRABAJADOR</h2>
                    </div>
                    <div className="col-8">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>CONSIDERACIONES</th>
                                    <th>SI O NO</th>
                                    <th>DETALLE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Haberes Pendientes (RRHH)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="pendientes" value="SI" id="chkpendientessi" onChange={(e) => setHaberes(e.target.value)} checked={haberes === "SI"} />
                                            <label className="form-check-label" htmlFor="chkpendientes">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="pendientes" value="NO" id="chkpendientesno" onChange={(e) => setHaberes(e.target.value)} checked={haberes === "NO"} />
                                            <label className="form-check-label" htmlFor="chkpendientesno">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control" value={detalleHaberes} onChange={(e) => setDetalleHaberes(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Días hábiles/ feriado a pagar (RRHH)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="feriado" value="SI" id="chkFeriado" onChange={(e) => setDias(e.target.value)} checked={dias === "SI"} />
                                            <label className="form-check-label" htmlFor="chkFeriado">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="feriado" value="NO" id="chkFeriado2" onChange={(e) => setDias(e.target.value)} checked={dias === "NO"} />
                                            <label className="form-check-label" htmlFor="chkFeriado2">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control" value={detalleDias} onChange={(e) => setDetalleDias(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Días descanso jornada excepcional a pagar (RRHH)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="excepcional" value="SI" id="chkexcepcional" onChange={(e) => setDescanso(e.target.value)} checked={descanso === "SI"} />
                                            <label className="form-check-label" htmlFor="chkexcepcional">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="excepcional" value="NO" id="chkexcepcional2" onChange={(e) => setDescanso(e.target.value)} checked={descanso === "NO"} />
                                            <label className="form-check-label" htmlFor="chkexcepcional2">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" value={detalleDescanso} className="form-control" onChange={(e) => setDetalleDescanso(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Entrega de equipos (Secretaria)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="equipo" value="SI" id="equiposi" onChange={(e) => setEquipo(e.target.value)} checked={equipo === "SI"} />
                                            <label className="form-check-label" htmlFor="equiposi">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="equipo" value="NO" id="equipono" onChange={(e) => setEquipo(e.target.value)} checked={equipo === "NO"} />
                                            <label className="form-check-label" htmlFor="equipono">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" value={detalleEquipo} className="form-control" onChange={(e) => setDetalleEquipo(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fecha finiquito:</td>
                                    <td colSpan={2}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                            <DatePicker
                                                label="Fecha Finiquito"
                                                value={finiquito}
                                                onChange={(newValue) => setFiniquito(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Turno:</td>
                                    <td>
                                        {/* <input type="text" value={turno} className="form-control" onChange={(e) => setTurno(e.target.value)} /> */}
                                        <TextField
                                            label="Turno"
                                            variant="outlined"
                                            onChange={(e) => setTurno(e.target.value)}
                                            fullWidth
                                            select
                                        >
                                            <MenuItem value="4X4">4X4</MenuItem>
                                            <MenuItem value="8X6">8X6</MenuItem>
                                            <MenuItem value="7X7">7X7</MenuItem>
                                            <MenuItem value="4X3">4X3</MenuItem>
                                            <MenuItem value="14X14">14X14</MenuItem>
                                            <MenuItem value="5X2">5X2</MenuItem>
                                            <MenuItem value="ART 22">ART 22</MenuItem>
                                        </TextField>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Ultimo día efectivo trabajado:</td>
                                    <td>
                                        {/* <input type="text" value={ultimodiaturno} className="form-control" onChange={(e) => setUltimodiaturno(e.target.value)} /> */}
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                            <DatePicker
                                                label="Ultimo día efectivo trabajado"
                                                value={ultimodiaturno}
                                                onChange={(newValue) => setUltimodiaturno(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Comentarios:</td>
                                    <td><textarea rows={4} value={comentarioRRHH} className="form-control" onChange={(e) => setComentarioRRHH(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-8">
                        <div className="mb-3">
                            <SignatureCanvas
                                canvasProps={{
                                    className: "sginatureCanvas"
                                }}
                                ref={(ref) => { setSigPad(ref) }}
                            />
                        </div>
                        <div className="bd-example">
                            <button className="btn btn-primary" onClick={Ingresar}>Ingresar</button>
                            <button className="btn btn-secondary" onClick={limpiarFirma} >Limpiar Firma</button>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {aprobado.map((a, i) => {
                        var data_uri = "data:image/png;base64," + a.firma;
                        return (
                            <div className="col-4" key={i}>
                                <img src={data_uri} className="signatureShow" width="100%" height="250" />
                                <div className="form-text">
                                    <p className="text-center">{a.tipo}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {/** Modal para ingresasr documentos */}
                <Modal
                    open={open}
                    onClose={closeModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                            Subir Documento
                        </Typography>
                        <Stack spacing={2} direction="row">
                            <TextField
                                label="Nombre Documento"
                                onChange={(e) => setNombreArchivo(e.target.value)}
                            />
                            <Button variant="contained" component="label">
                                Subir
                                <input hidden accept="image/*" multiple type="file" onChange={(e) => setArchivo(e.target.files)} />
                            </Button>
                            <LoadingButton
                                color="secondary"
                                //onClick={handleClick}
                                //loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="contained"
                                onClick={guardarDocumento}
                            >
                                Guardar
                            </LoadingButton>
                        </Stack>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Ingeso de documento a la hoja de vida del trabajador.
                        </Typography>
                    </Box>
                </Modal>
            </div>
        )
    )
}

//export default FiniquitoParte2;
export default function FiniquitoParte2Notistack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <FiniquitoParte2 />
        </SnackbarProvider>
    );
}